import { Flame } from 'lucide-react';
import { usePracticeStats } from '@/hooks/mindspace/usePracticeHistory';

/**
 * Small flame counter rendered in the Practice Arena page header.
 * Backed by the durable learning streak from the backend (meaningful
 * StudySession days, all-time) - so it isn't capped by the 50-session
 * practice log and matches the streak shown on the Progress page. Silent
 * reset - no notifications, no scolding.
 */
export function StreakBadge() {
  const { data } = usePracticeStats();
  const current = data?.streak_current ?? 0;
  const best = data?.streak_best ?? 0;

  if (current <= 0) return null;

  return (
    <span
      className='dark:tint-brand inline-flex items-center gap-1 rounded-full border border-brand-200 bg-brand-50 px-2 py-0.5 text-xs font-semibold text-brand-700 dark:border-primary/60'
      title={
        best > current
          ? `${current} day streak · best ${best}`
          : `${current} day streak`
      }
      aria-label={`${current} day practice streak${best > current ? `, best ${best}` : ''}`}
    >
      <Flame className='h-3 w-3' />
      <span className='tabular-nums'>{current}</span>
      {/* Subordinated by WEIGHT, not by alpha. `opacity-70` measured 3.46:1
          on this badge's own fill and failed AA — the same defect this route
          has now shipped six times, always because a faded label looks
          correct to the person who wrote it. */}
      <span className='font-normal'>day{current === 1 ? '' : 's'}</span>
    </span>
  );
}
